// @ts-nocheck
import { PhoneNumberUtil } from 'google-libphonenumber'

import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
// 全てのルールをインポート
import {
  confirmed,
  email,
  image,
  length,
  max,
  min,
  numeric,
  regex,
  required,
  required_if,
  size,
  mimes,
} from 'vee-validate/dist/rules'
import Vue from 'vue'
import { i18n } from './i18n'
import { AvailableLang } from '@app/types/src/Lang'
const ja = require('vee-validate/dist/locale/ja.json')

extend('required', required)
extend('required_if', required_if)
extend('email', email)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('confirmed', confirmed)
extend('regex', regex)
extend('image', image)
extend('mimes', mimes)
extend('size', size)
extend('length', length)
extend('phone', {
  params: ['lang'],
  message: i18n.t('電話番号の形式が不正です'),
  validate(value, params) {
    // const util = PhoneNumberUtil.getInstance()
    // // AvailableLangのなかのどれかの電話番号でvalidならtrueを返す
    // let valid = false
    // for (const availableLangKey in AvailableLang) {
    //   if (availableLangKey !== 'Undefined') {
    //     try {
    //       const phoneNumber = util.parseAndKeepRawInput(value, availableLangKey)
    //       if (util.isValidNumber(phoneNumber)) {
    //         // console.log(util.getRegionCodeForNumber(phoneNumber))
    //         valid = true
    //       }
    //     } catch (err) {
    //       // エラーは無視して他の言語をチェックする
    //     }
    //   }
    // }
    // return valid
    return true
  },
})
extend('serial', {
  message: i18n.t('半角英数字とハイフンで入力してください'),
  validate(value: string) {
    if (value.match(/^[A-Za-z0-9\-]*$/)) {
      return true
    } else {
      return false
    }
  },
})

// メッセージを設定
localize('ja', ja)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
